export default {
  root: { display: 'flex', width: '800px', marginBottom: '30px' },
  info: { textAlign: 'center', fontSize: '12px' }
};
